/* gk-promo-combo */
if (!customElements.get('gk-promo-combo')) {
  class GkPromoCombo extends HTMLElement {
    connectedCallback() {
      this.classList.add('gkpc--v2');

      this.hEl = this.querySelector('[data-gkpc-h]');
      this.mEl = this.querySelector('[data-gkpc-m]');
      this.sEl = this.querySelector('[data-gkpc-s]');
      this.barFill = this.querySelector('[data-gkpc-bar]');

      // Texto entre parênteses do título vai para uma nota pequena no fundo da caixa
      const label = this.querySelector('.gkpc__label');
      if (label && !this.querySelector('.gkpc__note')) {
        const m = label.textContent.trim().match(/^(.*?)\s*(\([^)]*\))\s*$/);
        if (m && m[1]) {
          label.textContent = m[1];
          const note = document.createElement('p');
          note.className = 'gkpc__note';
          note.textContent = m[2];
          (this.querySelector('.gkpc__inner') || this).appendChild(note);
        }
      }
      // Raio antes de "OFERTA EXCLUSIVA"
      if (label && !label.querySelector('.gkpc__bolt')) {
        const bolt = document.createElement('span');
        bolt.className = 'gkpc__bolt';
        bolt.setAttribute('aria-hidden', 'true');
        bolt.innerHTML =
          '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M13.2 2 4.5 13.4h6.2L9.8 22l8.7-11.4h-6.2L13.2 2z"/></svg>';
        label.insertBefore(bolt, label.firstChild);
      }
      // "Termina em" antes do cronometro (a bola preta do cronometro fica igual)
      const timer = this.querySelector('.gkpc__timer');
      if (timer && !this.querySelector('.gkpc__ends')) {
        const ends = document.createElement('span');
        ends.className = 'gkpc__ends';
        ends.textContent = 'Termina em';
        timer.parentNode.insertBefore(ends, timer);
      }
      // Aviso discreto, FORA da caixa e logo por baixo: o desconto entra sozinho no carrinho
      const nextEl = this.nextElementSibling;
      if (!(nextEl && nextEl.classList.contains('gkpc__auto')) && this.parentNode) {
        const auto = document.createElement('p');
        auto.className = 'gkpc__auto';
        auto.style.cssText =
          'display:flex;align-items:center;justify-content:center;gap:0.4rem;margin:0 0 1.4rem;font-size:1.1rem;font-weight:500;line-height:1.3;letter-spacing:0.01em;color:#6b7280;text-align:center;';
        auto.innerHTML =
          '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="#22a35a" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="flex:0 0 auto"><polyline points="5 12.5 10 17 19 7"/></svg>' +
          '<span>Aplicado automaticamente no carrinho</span>';
        this.parentNode.insertBefore(auto, this.nextSibling);
        this.style.setProperty('margin-bottom', '0.7rem', 'important');
      }

      this.target = this.calcNextMidnight();
      this.dayMs = 24 * 60 * 60 * 1000;

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    calcNextMidnight() {
      const now = new Date();
      const next = new Date(now);
      next.setHours(24, 0, 0, 0);
      return next.getTime();
    }

    tick() {
      const now = Date.now();
      let diff = this.target - now;

      if (diff <= 0) {
        this.target = this.calcNextMidnight();
        diff = this.target - now;
      }

      const totalSeconds = Math.floor(diff / 1000);
      const h = Math.floor(totalSeconds / 3600);
      const m = Math.floor((totalSeconds % 3600) / 60);
      const s = totalSeconds % 60;

      if (this.hEl) this.hEl.textContent = this.pad(h);
      if (this.mEl) this.mEl.textContent = this.pad(m);
      if (this.sEl) this.sEl.textContent = this.pad(s);

      if (this.barFill) {
        // Quanto MAIOR a porcentagem, mais perto da meia-noite (oferta acabando)
        const pct = 100 - (diff / this.dayMs) * 100;
        this.barFill.style.width = Math.max(0, Math.min(100, pct)) + '%';
      }
    }

    pad(n) {
      return String(n).padStart(2, '0');
    }
  }
  customElements.define('gk-promo-combo', GkPromoCombo);
}
